import*as r from"react";function t(t){return r.Children.toArray(t).filter((t=>r.isValidElement(t)))}export{t as g};
